"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const canvas_1 = require("@rive-app/canvas");
class default_1 {
    constructor(container, animationName, assetFolder, riveParameters = {}) {
        this.container = container;
        this.animationName = animationName;
        this.assetFolder = assetFolder;
        this.riveParameters = riveParameters;
        this.dontShowSelector = "body.iphone";
        if (document.querySelector(this.dontShowSelector)) {
            return;
        }
        if (!this.isHidden(this.container)) {
            this.mountCanvas(this.container);
        }
        else {
            const observerOptions = {
                childList: true,
                subtree: true,
                attributes: true,
            };
            const elementToWatch = document.querySelector("body");
            if (!elementToWatch) {
                return;
            }
            const observer = new MutationObserver(() => {
                if (!this.isHidden(this.container)) {
                    observer.disconnect();
                    this.mountCanvas(this.container);
                }
            });
            observer.observe(elementToWatch, observerOptions);
        }
    }
    mountCanvas(canvas) {
        canvas.style.display = "block";
        const layout = new canvas_1.Layout({
            fit: canvas_1.Fit.Fill,
        });
        const params = Object.assign({ src: `${this.assetFolder}${this.animationName}.riv`, canvas, autoplay: true, layout }, this.riveParameters);
        new canvas_1.Rive(params);
        canvas.classList.remove("unloaded");
        canvas.classList.add("loaded");
        this.hidePlaceholder(canvas);
    }
    hidePlaceholder(canvas) {
        const previousSibling = canvas.previousElementSibling;
        if (previousSibling.nodeName === "IMG") {
            previousSibling.style.display = "none";
        }
    }
    isHidden(el) {
        return el.offsetParent === null;
    }
}
exports.default = default_1;
